import axios, { Method } from 'axios'

export const request = (
  query: any,
  variables: any,
  path?: string,
  method: Method = 'POST'
) => {
  const url = `${process.env.REACT_APP_BLINKER_API_URL}${
    path || '/admin/graphql'
  }`

  // Accept GraphQL strings or graphql-loader modules (with .default)
  const gql = query && typeof query !== 'string' && query.default ? query.default : query

  if (gql) {
    const json = JSON.stringify(variables)
    return axios.post(url, {
      query: gql,
      variables: json,
    })
  } else {
    return axios({
      method,
      url,
      data: variables,
    })
  }
}

export const getApiRequest = (path) => {
  return axios.get(
    `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/${path}`
  )
}

export const postApiRequest = (path, body = {}) => {
  return axios.post(
    `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/${path}`,
    body
  )
}

export const putApiRequest = (path, body) => {
  return axios.put(
    `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/${path}`,
    body
  )
}

export const deleteApiRequest = (path: string) => {
  return axios.delete(
    `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/${path}`
  )
}
